import { useTranslation } from "react-i18next";

export const Loading = ({ loadingText }) => {
    const { t } = useTranslation();
    return (
        <div
            className="d-flex align-items-center justify-content-between"
            style={{ gap: "1rem" }}
        >
            <strong
                className="mb-0"
                style={{
                    flex: "1 1 auto",
                    minWidth: 0,
                    whiteSpace: "normal",
                    lineHeight: 1.35,
                }}
            >
                {!loadingText ? t("common:loading") : loadingText}
            </strong>
            <span
                style={{ width: "2.75rem", height: "2.75rem", flex: "0 0 auto" }}
                className="spinner-border spinner-border-sm align-middle"
            ></span>
        </div>
    );
}

export const LoadingCard = ({ loadingText, className }) => {
    return (
        <div className={`card shadow-sm ${className}`}>
            <div className="card-body">
                <Loading loadingText={loadingText} />
            </div>
        </div>
    );
};
